import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push
// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace
// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location){
return originalPush.call(this , location).catch(err=>err)
}
 
// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}
const routes = [
  {
    path: '/',
    redirect:'/login'
  },
  {
    path:'/login',
    name:'Login',
    component: () => import('../views/login.vue'),
    meta:{
      jishuzhichi:false,
    }
  },
  {
    path:'/register',
    name:'Register',
    component: () => import('../views/register.vue'),
    meta:{
      jishuzhichi:false,
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to,from,next) => {
  if(to.path == '/logout'){
    router.replace({path:'/',force: true })
    next()
  }
  next()
})

export default router
